<template>
  <div class="map-container">
    <div class="map">
      <FieldMap :center="center" :zoom="mapCenterPoint.zoom" mini>
        <SingleJobLayer
          :selected-job-number="jobNumber"
          @total-distance-calculated="handleNewMapLegacyDistanceCalculation"
        />
      </FieldMap>
    </div>
    <vs-button
      v-if="mapLink"
      :to="mapLink"
      icon="open_in_full"
      small
      label="Expand"
      type="inverted"
      class="expand-button"
    ></vs-button>
  </div>
</template>

<script setup lang="ts">
import FieldMap from '@/components/field-view-next/mapbox/FieldMap.vue'
import SingleJobLayer from '@/components/field-view-next/layers/SingleJobLayer.vue'
import { useState } from 'vuex-composition-helpers'
import { computed } from 'vue'
import VsButton from '@/components/vision/VsButton.vue'

defineProps<{
  jobNumber: number
  mapLink?: string | null
}>()

const emits = defineEmits<{
  (event: 'distance-calculated', data: number)
}>()

const { mapCenterPoint } = useState('organizationConfig', ['mapCenterPoint'])
const center = computed(() => {
  return {
    lat: mapCenterPoint.value.latitude,
    lng: mapCenterPoint.value.longitude,
  }
})

const handleNewMapLegacyDistanceCalculation = (distance: number) => {
  emits('distance-calculated', distance)
}
</script>

<style scoped>
.map-container {
  overflow: auto;
  border-radius: var(--space-base);
  position: relative;
}

.map {
  height: 320px;
  margin-bottom: 20px;
}

.expand-button {
  position: absolute;
  top: 10px;
  right: 10px;
}
</style>
